import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/enum';
import type { IdParam, JsonOrFormBody, JsonRecord } from './types/api-payloads.types';

@Injectable({
  providedIn: 'root',
})
export class CommonPagesInvestmentService {
  constructor(private _cS: CommonService) {}

  updateReps(formData: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.UpdateRepsProfile, formData, false, {
      headers: hd,
    });
  }

  DeleteInvestment(formData: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.DeleteInvestment, formData, false, {
      headers: hd,
    });
  }

  GetInvestment(InvestmentId: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetInvestment + `?InvestmentId=${InvestmentId}`
    );
  }
  GetInvestorBySite(SiteId: IdParam, searchText: string) {
    return this._cS.API_GET(
      EndPoints.GetInvestorBySiteId +
        `?SiteId=${SiteId}&searchText=${searchText}`
    );
  }
  GetSiteDetails(SiteId: IdParam) {
    return this._cS.API_GET(EndPoints.GetSiteDetailsById + `?siteId=${SiteId}`);
  }
  updateInvestment(investmentData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateInvestment, investmentData);
  }
  ApproveInvestment(investmentData: JsonRecord) {
    return this._cS.API_POST(EndPoints.ApproveInvestment, investmentData);
  }
  markAsReviewed(investmentId: IdParam) {
    return this._cS.API_POST(
      EndPoints.ReviewInvestment + `?investmentId=${investmentId}`,
      null
    );
  }
  SaveInvestment(investmentData: JsonRecord) {
    return this._cS.API_POST(EndPoints.SaveInvestment, investmentData);
  }
  setInvestmentBalanceTransferFlag(body: {
    investmentId: string;
    isBalanceTransfer: boolean;
  }) {
    return this._cS.API_POST(EndPoints.SetInvestmentBalanceTransferFlag, body);
  }
  ScheduleInvestment(investmentData: JsonRecord) {
    return this._cS.API_POST(EndPoints.ScheduleInvestment, investmentData);
  }
  GetUserSites(isSupplierInvestment: boolean) {
    return this._cS.API_GET(
      EndPoints.GetUserSites + `?IsSupplierRequest=${isSupplierInvestment}`,
      false
    );
  }
  GetInvestorDetail(InvestorId: IdParam, isSupplierInvestment: boolean) {
    return this._cS.API_GET(
      EndPoints.GetInvestorDetails +
        `?InvestorId=${InvestorId}&isSupplierRequest=${isSupplierInvestment}`
    );
  }
  GetInvestorDetailBYQBOID(investorQBOId: IdParam, siteId: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetInvestorAndSiteDetails +
        `?InvestorQboId=${investorQBOId}&SiteId=${siteId}`
    );
  }
  GetInvestorDetailQBO(InvestorId: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetInvestorDetailsQBO + `?id=${InvestorId}`
    );
  }
  getProgramBySite(siteId: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetProgramBySite + `?siteId=${siteId}`,
      false
    );
  }

  MapWithExistingCustomer(formData: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.MapWithExistingCustomer,
      formData,
      false,
      {
        headers: hd,
      }
    );
  }
  MapRetailSupplierToQboCustomer(requestBody: JsonRecord) {
    return this._cS.API_POST(
      EndPoints.MapRetailSupplierToQboCustomer,
      requestBody,
      false
    );
  }

  AddNewCustomer(customerBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddNewCustomer, customerBody);
  }
  GetSuppliersList() {
    return this._cS.API_GET(EndPoints.GetSuppliersList);
  }
  GetRepsName() {
    return this._cS.API_GET(EndPoints.GetRepsName);
  }
  GetUnmappedQboSuppliers() {
    return this._cS.API_GET(EndPoints.GetUnmappedQboSuppliers);
  }

  getEmailInvestmentDetails(investmentId: IdParam, link: string) {
    return this._cS.API_GET(
      EndPoints.GetEmailInvestmentDetails +
        `?investmentId=${investmentId}&paybevLink=${link}`,
      false
    );
  }
  SendInvestmentIssueEmail(emailData: JsonRecord) {
    return this._cS.API_POST(EndPoints.SendInvestmentIssueEmail, emailData);
  }

  resyncInvestmentData(investmentId: IdParam) {
    return this._cS.API_GET(
      EndPoints.ResyncInvestmentData + `?InvestmentId=${investmentId}`
    );
  }
}
